"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationModule = void 0;
const neo_1 = require("./neo");
const playhub_1 = require("./playhub");
class IntegrationModule {
    constructor(axiosInstance) {
        this.neo = new neo_1.NeoIntegrationModule(axiosInstance);
        this.playhub = new playhub_1.PlayHubIntegrationModule(axiosInstance);
    }
}
exports.IntegrationModule = IntegrationModule;
//# sourceMappingURL=index.js.map